import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import rcbStyles from './RoundCornerButton.module.scss';

export class RoundCornerButton extends React.PureComponent {
	static propTypes = {
		text: PropTypes.string,
		onClick: PropTypes.func,
		className: PropTypes.string,
		textClassName: PropTypes.string,
		disabled: PropTypes.bool
	}
	static defaultProps = {
		className: 'px-4 py-1 bg-cerulean',
		textClassName: null,
		disabled: false
	}

	render() {
		const { text, onClick, className, textClassName, disabled } = this.props;

		const blockClasses = classNames([
			'flex',
			'items-center',
			'justify-around',
			'focus:outline-none',
			'rounded-full',
			className
		]);

		return (
			<button
				type="button"
				className={classNames(blockClasses, disabled && rcbStyles['disable-button'])}
				disabled={disabled}
				onClick={onClick}>
				<p className={textClassName}>{text}</p>
			</button>
		);
	}
}
